<img *ngIf="base64" class="bg-white rounded-full h-10 w-10 border border-gray-300" [src]="'data:image/png;base64, ' + base64" alt="Avatar" />
<div *ngIf="name && !base64" class="rounded-full h-10 w-10 border border-white flex items-center justify-center bg-laureate-500 text-white">
    {{ generateInitials() }}
</div>